import { ProductData } from 'utils/types';
import { StyledLoyaltyPoints } from './style';

interface ILoyaltySubProductProps {
  loyaltySubProduct: ProductData;
}

export const LoyaltySubProduct: React.FC<ILoyaltySubProductProps> = ({
  loyaltySubProduct,
}) => {
  return (
    <StyledLoyaltyPoints gap={'4px'} title={loyaltySubProduct.quantityDisplay}>
      <img src={loyaltySubProduct.images.product} alt="loyalty" />
      <div className="quantity_text">{loyaltySubProduct.quantityDisplay}</div>
    </StyledLoyaltyPoints>
  );
};
